import { Sentry } from '@boot/sentry.js';
/**
 * Reports an exception to Sentry.
 * https://docs.sentry.io/platforms/javascript/usage/
 * @param error - The error to report.
 */
export function reportExceptionToSentry(error) {
    if (Sentry && Sentry.captureException) {
        Sentry.captureException(error);
    }
}
/**
 * Get the resolution duration in minutes.
 * @param resolution - The resolution type
 * @returns Resolution in minutes, or null if unknown/variable
 */
export function getResolutionInMinutes(resolution) {
    const resolutionMap = {
        hourly: 60,
        '60-minute': 60,
        daily: 1440, // 24 * 60
        '24-hour': 1440,
        weekly: 10080, // 7 * 24 * 60
        '7-day': 10080,
        monthly: null // Variable, skip validation for monthly
    };
    return resolutionMap[resolution] ?? null;
}
/**
 * Check if total operating time exceeds the report resolution and log a Sentry warning.
 * @param params - Parameters for the operating time check
 */
export function checkOperatingTimeExceedsResolution(params) {
    const { asset_id, asset_name, period, total_operating_time, resolution, facility_name } = params;
    const resolutionMinutes = getResolutionInMinutes(resolution);
    if (resolutionMinutes === null)
        return;
    if (total_operating_time > resolutionMinutes) {
        const exceededBy = (total_operating_time - resolutionMinutes).toFixed(2);
        Sentry.captureMessage('Total operating time exceeds resolution period', {
            level: 'warning',
            tags: {
                component: 'TrendsReportBuilder',
                resolution
            },
            extra: {
                asset_id,
                asset_name,
                period,
                total_operating_time_minutes: total_operating_time,
                resolution_minutes: resolutionMinutes,
                exceeded_by_minutes: exceededBy,
                facility_name
            }
        });
    }
}
